import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip } from "@mui/material";
import { Help }from '@mui/icons-material'

// Documentation page component
import { TextareaAutosize } from "@mui/material";

// Documentation page component
const DocumentationPage = () => {
  const exampleInput = "Send Button\nLogin Button\nSending Message";
  const exampleTranslations = {
    "en": {
      "Send Button": "Send Button",
      "Login Button": "Login Button",
      "Sending Message": "Sending Message"
    },
    "fr": {
      "Send Button": "Bouton Envoyer",
      "Login Button": "Bouton Connexion",
      "Sending Message": "Envoi de Message"
    },
    "es": {
      "Send Button": "Botón de Envío",
      "Login Button": "Botón de Inicio de Sesión",
      "Sending Message": "Enviando Mensaje"
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold mb-6">String Localizer Documentation v1.0</h1>
      
      {/* Section: Introduction */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Introduction</h2>
        <p>
          Welcome to the Translation App! This application allows you to easily
          translate text from one language to another using the Google Translate API.
        </p>
      </section>

      {/* Section: Getting Started */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Getting Started</h2>
        <p>
          To get started, follow these simple steps:
        </p>
        <ol className="list-decimal ml-6">
          <li>Enter the text you want to translate in the "Input" section.</li>
          <li>Select the input language from the dropdown menu.</li>
          <li>Select the target languages by checking the checkboxes.</li>
          <li>Click the "Translate" button to see the translation results.</li>
        </ol>
      </section>

      {/* Section: Input Section */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Input Section</h2>
        <p>
          The "Input" section allows you to enter the text you want to translate and choose
          the input language.
        </p>
        {/* You can add more details or images to explain the input section */}
      </section>

      {/* Section: Output Section */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Output Section</h2>
        <p>
          The "Output" section displays the translated text in the selected target languages.
          You can copy the translation to the clipboard or download it as a .txt file.
        </p>
        {/* You can add more details or images to explain the output section */}
      </section>

      {/* Section: Additional Features */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Additional Features</h2>
        <p>
          Explore additional features such as copying the translation to the clipboard and
          downloading it as a .txt file using the provided buttons.
        </p>
        {/* You can add more details or images to explain additional features */}
      </section>

      {/* Section: Example Input */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Example Input</h2>
        <p>
          Here is an example of the type of strings you might input into the application:
        </p>
        <TextareaAutosize
          className="p-3 w-full my-4 border-2 border-customGray"
          minRows={5}
          value={exampleInput}
          readOnly
        />
      </section>

      {/* Section: Example Translations */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Example Translations</h2>
        <p>
          Below is an example of the translated texts in three different languages:
        </p>
        <div className="grid grid-cols-3 gap-4">
          {Object.entries(exampleTranslations).map(([language, translations]) => (
            <div key={language}>
              <h3 className="text-xl font-bold mb-2">{language.toUpperCase()}</h3>
              <TextareaAutosize
                className="p-3 w-full my-4 border-2 border-customGray"
                minRows={5}
                value={JSON.stringify(translations, null, 2)}
                readOnly
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};


// Documentation popup component
const DocumentationPopup = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

        <Tooltip title={"Documentation"}>
            <IconButton endIcon={<Help/>} onClick={handleOpen} color="inherit"><Help/></IconButton>
        </Tooltip>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Translation App Documentation</DialogTitle>
        <DialogContent dividers>
          <DocumentationPage />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DocumentationPopup;
